import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import Access_ControlActions from "../../../Actions/Access_ControlActions";
import Access_ControlConstants from "../../../Constants/Access_ControlConstants";
import access_ControlStore from "../../../Stores/Access_ControlStores";
import {
  useItemSelectedFilterContext,
  useSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import { useMainGridSortActionContext } from "../../../Context/GlobalContext";
import StatusSelectionComponent from "./StatusSelectionComponent";
import AppConstants from "../../../Constants/AppConstants";
function EquipmentBulkUpdate(props) {
  const {
    handleClose,
    rowCount,
    bulkUpdatePopOver,
    slectedAction,
    reportCode,
    handleEqListTableRefersh,
  } = props;

  const selectedFilter = useSelectedFilterContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [month, setMonth] = useState([]);
  const [day, setDay] = useState();
  const [year, setYear] = useState([]);
  const [openStatusDialog, setopenStatusDialog] = useState(false);
  const monthName = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [dayTracker, setDayTracker] = useState("");
  const [monthTracker, setMonthTracker] = useState("");
  const [yearTracker, setYearTracker] = useState("");
  const [isLeap, setIsLeap] = useState(false);
  const [attributeDetailsList, setAttributeDetailsList] = useState([]);
  const [attributeDetailsDropDown, setAttributeDetailsDropDown] = useState([]);
  const [
    selectedAttributeDetailsDropDown,
    setselectedAttributeDetailsDropDown,
  ] = useState([]);
  const [isDropDown, setIsDropDown] = useState(false);
  const [FormControl, setFormControl] = useState(false);
  const [attributeSelected, setAttributeSelected] = useState("");
  const [selectedAttributeobj, setSelectedAttributeobj] = useState("");
  const [enteredValue, setEnteredValue] = useState("");
  const [dateFormControl, setDateFormControl] = useState(false);
  const [noEditableAttributesMessage, setNoEditableAttributesMessage] =
    useState("");
  const monthRef = useRef("");
  const [isMonth30, setIsMonth30] = useState("");
  const [inputForm, setInputForm] = useState("");
  const [isBool, setIsBool] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isCancelButton, setIsCancelButton] = useState(true);
  function RenderInputForm(type, nameAttribute) {
    setInputForm([{ type, nameAttribute }]);
  }

  const message = (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <p>
            {localization.thisWillUpdate}

            <span className="font-weight-bold ml-1 mr-1">{rowCount}</span>

            {selectedFilter === ""
              ? localization.equipment
              : localization.filteredEquipment}
          </p>
        </div>
        <div className="row justify-content-center">
          <p>
            <span className="font-weight-bold">
              {localization.thisActionIsIrreversible}
            </span>
          </p>
        </div>
        <div className="row justify-content-center">
          <span className="font-weight-bold">
            <p>{localization.thisMayTakeFewSecond}</p>
          </span>
        </div>
        <div className="row justify-content-center">
          <span className="font-weight-bold">
            <p>{localization.updateConfirmation}</p>
          </span>
        </div>
      </div>
    </>
  );

  const message1 = (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <p>
            {localization.bulkDeleteTitleMesag1}
            <span className="font-weight-bold ml-1 mr-1"> {rowCount} </span>
            {localization.bulkDeleteTitleMesag2}
          </p>
        </div>
        <div className="row justify-content-center">
          <p>
            <span className="font-weight-bold">
              {localization.bulkDeleteTitleMesag3}
            </span>
          </p>
        </div>

        <div className="row justify-content-center">
          <span className="font-weight-bold">
            <p>{localization.updateConfirmationDelete}</p>
          </span>
        </div>
      </div>
    </>
  );

  const handleConfirmmation = (_status) => {
    setIsCancelButton(itemSelectedFilter.length === 0 ? false : true);
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(
      itemSelectedFilter.length === 0
        ? slectedAction === "BulkDelete"
          ? localization.selecteFilterMsgDelete
          : localization.equipmentBulkStatusConfirmation
        : slectedAction === "BulkDelete"
          ? message1
          : `${localization.equipmentBulkStatusEquipmentSelect} ${rowCount} ${
              _status === "OutOperation"
                ? localization.eqOutService
                : localization.equActive
            } ${localization.continueConfirmation}`,
    );
    setCallbackData(
      itemSelectedFilter.length === 0
        ? {
            finalObject: "",
          }
        : slectedAction === "BulkDelete"
          ? {
              StandardAttributId: AppConstants.DEFAULT_GUID,
              Value: "",

              EquipmentGroupID: sessionStorage.getItem("eqGId"),
              RequestFilters: itemSelectedFilter,
            }
          : {
              StandardAttributId: AppConstants.DEFAULT_GUID,
              Value: "",
              EquipmentStatus:
                _status === "OutOperation" ? "AUSSER BETRIEB" : "INBE",
              EquipmentGroupID: sessionStorage.getItem("eqGId"),
              RequestFilters: itemSelectedFilter,
              ReportId: reportCode,
            },
    );
    setEventType(
      itemSelectedFilter.length === 0
        ? "Filter_Not_Selected"
        : slectedAction === "BulkDelete"
          ? "SET_BULK-DELETE"
          : "SET_BULK_STATUS_UPDATE",
    );
  };

  useEffect(() => {
    if (bulkUpdatePopOver && slectedAction === "BulkUpdate") {
      setGlobalSpinner(true);
      Access_ControlActions.getAnlageAttributeBulkUpdateForm(
        sessionStorage.getItem("eqGId"),
      );
    } else if (
      bulkUpdatePopOver &&
      (slectedAction === "BulkDelete" || slectedAction === "BulkStatusUpdate")
    ) {
      if (itemSelectedFilter.length == 0 || slectedAction === "BulkDelete") {
        handleConfirmmation(null);
      } else {
        handleStatusUpdate();
      }
    }
  }, [bulkUpdatePopOver]);

  useEffect(() => {
    if (attributeSelected !== "") {
      attributeDetailsList.map((item) => {
        if (item.bezeichnung === attributeSelected) {
          setSelectedAttributeobj(item);

          if (item.typ.toLowerCase() === "string") {
            if (item.isDropdown) {
              setIsBool(false);
              setDateFormControl(false);
              setselectedAttributeDetailsDropDown(item.dropdownValue);
              setIsDropDown(true);
              setFormControl(true);
            } else {
              RenderInputForm("text", item.bezeichnung);
              setIsBool(false);
              setDateFormControl(false);
              setFormControl(true);
              setIsDropDown(false);
            }
          } else {
            if (item.typ.toLowerCase() === "datetime") {
              setYearTracker("");
              setMonthTracker("");
              setDayTracker("");
              setIsBool(false);
              setDateFormControl(true);
            }
            if (
              item.typ.toLowerCase() === "int" ||
              item.typ.toLowerCase() === "float"
            ) {
              RenderInputForm("number", item.bezeichnung);
              setIsBool(false);
              setDateFormControl(false);
              setFormControl(true);
              setIsDropDown(false);
            }
            if (item.typ.toLowerCase() === "bool") {
              setDateFormControl(false);
              setIsDropDown(false);
              setFormControl(false);
              setIsBool(true);
            }
          }
        }
      });
    }
  }, [attributeSelected]);

  useEffect(() => {
    function getAnlageAttributeBulkDetailSuccess() {
      const res = access_ControlStore.getAnlageAttributeBulkDetails();

      if (res.length > 0) {
        setAttributeDetailsList(res);
        setAttributeDetailsDropDown(res);
      } else {
        setAttributeDetailsDropDown([]);
        setNoEditableAttributesMessage(localization.noEditableAttributeFound);
      }
      setGlobalSpinner(false);
    }

    function getAnlageAttributeBulkDetailFailure() {
      const res = access_ControlStore.getAnlageAttributeBulkDetails();
      setGlobalSpinner(false);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
      getAnlageAttributeBulkDetailSuccess,
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_FAILURE,
      getAnlageAttributeBulkDetailFailure,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
        getAnlageAttributeBulkDetailSuccess,
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_FAILURE,
        getAnlageAttributeBulkDetailFailure,
      );
    };
  }, []);

  useEffect(() => {
    let days = [];
    let months = [];
    let years = [];
    for (let i = 0; i < 31; i++) {
      days.push({ day: i + 1 });
    }
    setDay(days);
    for (let i = 0; i < 12; i++) {
      months.push({ value: i + 1, monthName: monthName[i] });
    }
    setMonth(months);
    for (
      let i = new Date().getFullYear();
      i < new Date().getFullYear() + 10;
      i++
    ) {
      years.push({ year: i });
    }
    setYear(years);
  }, []);

  useEffect(() => {
    if (dayTracker !== "") {
      setDayTracker("");
    }
    if (monthTracker !== monthRef.current) {
      monthRef.current = monthTracker;
      if (parseInt(monthTracker) === 8) {
        setIsMonth30(false);
      } else {
        if (parseInt(monthTracker) > 8) {
          if (parseInt(monthTracker) % 2 === 0) {
            setIsMonth30(false);
          } else {
            setIsMonth30(true);
          }
        } else {
          if (parseInt(monthTracker) % 2 === 0) {
            setIsMonth30(true);
          } else {
            setIsMonth30(false);
          }
        }
      }
    }
    if (
      yearTracker !== "" &&
      parseInt(yearTracker) % 4 === 0 &&
      (parseInt(yearTracker) % 100 !== 0 || parseInt(yearTracker) % 400 === 0)
    ) {
      setIsLeap(true);
    }
  }, [monthTracker, yearTracker]);

  useEffect(() => {
    function updateBulkDeleteEquipmentDetailSuccess() {
      const res = access_ControlStore.getDeletBulkDetailsResult();

      if (res) {
        toast.success(localization.equipmentDeletedSuccessfully);
      }
      handleEqListTableRefersh();
    }
    function updateBulkDeleteEquipmentDetailFailure() {
      const res = access_ControlStore.getDeletBulkDetailsResult();
      handleClose();
      setGlobalSpinner(false);
      toast.error(res);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS,
      updateBulkDeleteEquipmentDetailSuccess,
    );
    access_ControlStore.addChangeListener(
      Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE,
      updateBulkDeleteEquipmentDetailFailure,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS,
        updateBulkDeleteEquipmentDetailSuccess,
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE,
        updateBulkDeleteEquipmentDetailFailure,
      );
    };
  }, []);

  useEffect(() => {
    function updateBulkStatusEquipmentSuccess() {
      const res = access_ControlStore.getUpdateStatusBulkResult();

      if (res) {
        toast.success(localization.equipmentStatusUpdateSuccess);
      }

      handleEqListTableRefersh();
    }
    function updateBulkStatusEquipmentFailure() {
      const res = access_ControlStore.getUpdateStatusBulkResult();
      handleClose();
      setGlobalSpinner(false);
      toast.error(res);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_SUCCESS,
      updateBulkStatusEquipmentSuccess,
    );
    access_ControlStore.addChangeListener(
      Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_FAILURE,
      updateBulkStatusEquipmentFailure,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_SUCCESS,
        updateBulkStatusEquipmentSuccess,
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_FAILURE,
        updateBulkStatusEquipmentFailure,
      );
    };
  }, []);

  function handleBulkUpdate(e) {
    e.preventDefault();
    if (itemSelectedFilter.length === 0) {
      setIsCancelButton(false);
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.selecteFilterMsg);
      setCallbackData({
        finalObject: "",
      });
      setEventType("Filter_Not_Selected");
    } else {
      setIsCancelButton(true);
      const fixedDate = dayTracker + "." + monthTracker + "." + yearTracker;

      const attributeData = {
        StandardAttributId: selectedAttributeobj.standardAttributId,
        Value: dateFormControl
          ? fixedDate
          : FormControl
            ? enteredValue
            : checked
              ? "true"
              : "false",
        EquipmentGroupID: sessionStorage.getItem("eqGId"),
        RequestFilters: itemSelectedFilter,
      };
      const submitObject = { ...attributeData };
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(
        slectedAction === "BulkUpdate" ? message : message1,
      );

      setCallbackData({
        finalObject: submitObject,
      });
      setEventType(
        slectedAction === "BulkUpdate" ? "SET_BULK-DATA" : "SET_BULK-DELETE",
      );
    }
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "SET_BULK-DATA": {
          setGlobalSpinner(true);
          const res = Access_ControlActions.saveUpdateAnlageBulkDetails({
            ...data.finalObject,
          });
          closePopUpCallback();
          break;
        }
        case "SET_BULK-DELETE": {
          setGlobalSpinner(true);
          const res = Access_ControlActions.bulkDeleteAnlageDetails({
            ...data,
          });
          closePopUpCallback();
          break;
        }
        case "SET_BULK_STATUS_UPDATE": {
          setGlobalSpinner(true);
          Access_ControlActions.bulkUpdateAnlageStatus({
            ...data,
          });
          closePopUpCallback();
          break;
        }
        case "Filter_Not_Selected":
          setIsCancelButton(true);
          handleClose();
          closePopUpCallback();
          break;
        case "SWITCH_TEST_CRITERION":
          setEnteredValue(data.finalObject);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      switch (eventType) {
        case "SET_BULK-DATA":
        case "SWITCH_TEST_CRITERION":
          closePopUpCallback();
          break;

        default:
          closePopUpCallback();
          handleClose();
          break;
      }
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function handleDropDownChange(_value) {
    if (
      selectedAttributeobj.code &&
      (selectedAttributeobj.code.toLowerCase() === "testgroup" ||
        selectedAttributeobj.code.toLowerCase() === "kost")
    ) {
      if (_value !== "") {
        const msg =
          selectedAttributeobj.code.toLowerCase() === "testgroup"
            ? localization.testGroupChangeAlertMsg +
              localization.genericContinueMsg
            : localization.costCenterChangeAlertMsg +
              localization.genericContinueMsg;
        setIsCancelButton(true);
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(msg);
        setCallbackData({
          finalObject: _value,
        });
        setEventType("SWITCH_TEST_CRITERION");
      }
    } else {
      setEnteredValue(_value);
    }
  }

  function handleStatusUpdate() {
    if (itemSelectedFilter.length > 0) {
      setopenStatusDialog(true);
    }
  }
  function handleCloseStausDialog() {
    setopenStatusDialog(false);
    handleClose();
  }
  function handleHandleOk(_status) {
    setopenStatusDialog(false);
    handleConfirmmation(_status);
  }
  return (
    <>
      {slectedAction === "BulkUpdate" && (
        <div
          className="modal in dialogBox "
          id="MsgModalCenter"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="MsgModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog d-flex justify-content-center"
            role="document"
          >
            <div className="modal-content modelStyle">
              <div className="modal-header">
                <h5 className="modal-title">
                  {slectedAction === "BulkUpdate"
                    ? localization.selectAttributeforUpdate
                    : localization.bulkDeleteTitle}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              {attributeDetailsList && attributeDetailsList.length > 0 ? (
                <form
                  id="updateAttribute"
                  name="updateAttribute"
                  onSubmit={handleBulkUpdate}
                >
                  <div className="modal-body ">
                    <div className="container">
                      <div className="row">
                        <div className="col pl-0 pr-0">
                          <div className="form-group">
                            <select
                              className="form-control"
                              id="selectAttribute"
                              name="selectAttribute"
                              required
                              value={attributeSelected}
                              onChange={(e) => {
                                setAttributeSelected(e.target.value);
                              }}
                            >
                              <option value={""} disabled>
                                {localization.selectAttribute}
                              </option>
                              {attributeDetailsDropDown.map((item, i) => {
                                return (
                                  <option value={item.bezeichnung} key={i}>
                                    {item.bezeichnung}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      {FormControl && !dateFormControl && (
                        <div className="row">
                          <div className="col pl-0 pr-0">
                            <div className="form-group">
                              {isDropDown ? (
                                <select
                                  className="form-control"
                                  id={selectedAttributeobj.bezeichnung}
                                  name={selectedAttributeobj.bezeichnung}
                                  required
                                  value={enteredValue}
                                  onChange={(e) => {
                                    handleDropDownChange(e.target.value);
                                  }}
                                >
                                  <option value={""} disabled>
                                    {localization.selectValue}
                                  </option>
                                  {selectedAttributeDetailsDropDown.map(
                                    (item, i) => {
                                      return (
                                        <option value={item.value} key={i}>
                                          {item.label}
                                        </option>
                                      );
                                    },
                                  )}
                                </select>
                              ) : (
                                <>
                                  {inputForm.map((item, i) => {
                                    return (
                                      <input
                                        key={i}
                                        type={item.type}
                                        id={selectedAttributeobj.bezeichnung}
                                        name={selectedAttributeobj.bezeichnung}
                                        className="form-control"
                                        required
                                        placeholder={localization.enterValue}
                                        value={enteredValue}
                                        onChange={(e) => {
                                          setEnteredValue(e.target.value);
                                        }}
                                      />
                                    );
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {dateFormControl && (
                        <div className="row">
                          <div className="col-4">
                            <div className="form-group">
                              <label className="form-label pl-2" htmlFor="year">
                                {localization.year}
                              </label>
                              <select
                                className="form-control"
                                id="year"
                                name="year"
                                required
                                value={yearTracker}
                                onChange={(e) => {
                                  setYearTracker(e.target.value);
                                }}
                              >
                                <option value={""} disabled>
                                  {localization.selectYear}
                                </option>
                                {year.map((item, index) => (
                                  <option value={item.year} key={index}>
                                    {item.year}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="form-group">
                              <label
                                className="form-label pl-2"
                                htmlFor="month"
                              >
                                {localization.month}
                              </label>

                              <select
                                className="form-control"
                                id="month"
                                name="month"
                                required
                                value={monthTracker}
                                onChange={(e) => {
                                  setMonthTracker(e.target.value);
                                }}
                              >
                                <option value={""} disabled>
                                  {localization.selectMonth}
                                </option>
                                {month.map((item, index) => (
                                  <option value={item.value} key={index}>
                                    {item.monthName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="form-group">
                              <label className="form-label pl-2" htmlFor="day">
                                {localization.day}
                              </label>
                              <select
                                className="form-control"
                                id="day"
                                name="day"
                                required
                                disabled={monthTracker === ""}
                                value={dayTracker}
                                onChange={(e) => {
                                  setDayTracker(e.target.value);
                                }}
                              >
                                <option value={""} disabled>
                                  {localization.selectDay}
                                </option>
                                {day.map((item, index) => (
                                  <option
                                    value={item.day}
                                    key={index}
                                    disabled={
                                      monthTracker === "2"
                                        ? isLeap
                                          ? item.day > 29
                                          : item.day > 28
                                        : isMonth30 && item.day > 30
                                    }
                                  >
                                    {item.day}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      )}
                      {isBool && (
                        <div className="row">
                          <div className="col-2 d-flex">
                            <label className="labelFont ml">
                              {selectedAttributeobj.bezeichnung}
                            </label>
                            <div className="ml-1 mt-1">
                              <input
                                type="checkbox"
                                id={selectedAttributeobj.bezeichnung}
                                name={selectedAttributeobj.bezeichnung}
                                defaultChecked={checked}
                                onChange={(e) => {
                                  setChecked(e.target.checked);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="form-group marProp">
                      <button type="submit" className="btn btn-primary mb-4 ">
                        {localization.save}
                      </button>
                    </div>
                  </div>
                </form>
              ) : (
                <>
                  <div className="modal-body ">
                    <br></br>
                    <div className="text-center">
                      <b>{noEditableAttributesMessage}</b>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={isCancelButton}
      />
      {openStatusDialog && (
        <StatusSelectionComponent
          handleClose={handleCloseStausDialog}
          handleoK={handleHandleOk}
        />
      )}
    </>
  );
}

export default EquipmentBulkUpdate;
